import * as React from "react";

function SvgIcTracking(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.25a.75.75 0 01.75.75v1.04a7.003 7.003 0 016.21 6.21H20a.75.75 0 010 1.5h-1.04a7.003 7.003 0 01-6.21 6.21V20a.75.75 0 01-1.5 0v-1.04a7.003 7.003 0 01-6.21-6.21H4a.75.75 0 010-1.5h1.04a7.003 7.003 0 016.21-6.21V4a.75.75 0 01.75-.75zm-.75 4.25v-.444a5.004 5.004 0 00-4.194 4.194H7.5a.75.75 0 010 1.5h-.444a5.003 5.003 0 004.194 4.194V16.5a.75.75 0 011.5 0v.444a5.003 5.003 0 004.194-4.194H16.5a.75.75 0 010-1.5h.444a5.003 5.003 0 00-4.194-4.194V7.5a.75.75 0 01-1.5 0zM12 14a2 2 0 100-4 2 2 0 000 4z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcTracking;
